import { render, staticRenderFns } from "./RoomDescription.vue?vue&type=template&id=d10d9092"
import script from "./RoomDescription.vue?vue&type=script&lang=ts"
export * from "./RoomDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports